/**

 * Generic JavaScript for IPP - v1.0 Chris Salt
 * 13/03/2014
 */

import $ from 'jquery';

$(document).ready(function () {

    var reformatSitsErrors;

    /*********************************************************************/
    /* FUNCTION DECLARATIONS                                             */
    /*********************************************************************/
    reformatSitsErrors = function () {
        let messageTitle;
        let messageContent;
        let $messageBox = $('.sv-message-box');

        //Find any sits error, hide and output Bootstrap styled error
        messageTitle = $messageBox.find('.sv-panel-heading').text();
        messageContent = $messageBox.find('.sv-panel-body').html();

        $messageBox
            .empty()
            .removeClass('sv-panel sv-panel-danger')
            .addClass('alert alert-danger')
            .append($('<p>', {'id': 'newmessagetitle'}).append($('<strong>').html('<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> ' + messageTitle)));
        $messageBox.append($('<p>', {'id': 'newmessagecontent'}).html(messageContent));

    };

    /*********************************************************************/
    /* EVENTS                                                            */
    /*********************************************************************/


    /*********************************************************************/
    /* RUN                                                               */
    /*********************************************************************/
    reformatSitsErrors();
});



// WEBPACK FOOTER //
// ./ku/js/ola_general.js